// extracted by mini-css-extract-plugin
export var actionButton = "_7x-0";
export var attachmentLine = "_7x-1";
export var fileInput = "_7x-2";
export var fileUploadWrapper = "_7x-4";
export var footer = "_7x-3";
export var modalContent = "_7x-5";
export var paperclip = "_7x-6";
export var quillEditor = "_7x-7";